import AppState from '../../interfaces/app-state';

export const selectServicePrices = (state: AppState) => state.platformConfig.servicePrices;
export const selectCityConfigs = (state: AppState) => state.platformConfig.cityConfigs;
export const selectCheckoutPause = (state: AppState) => state.platformConfig.checkoutPause;
export const selectIsCheckoutPaused = (state: AppState) => state.platformConfig.checkoutPause?.enabled === true;
